<div class="wrapper">
  <div class="gms-container sub-sidebar-z-index">
    <div class="sub-menu-wrapper">
      <span class="sub-menu-title">
        {{ selectedPrimaryNavConfig?.label }}
      </span>
      @for (secondaryNavConfig of secondaryNavConfigs; track secondaryNavConfig.id){
      <ng-container>
        <app-infopost-sidebar-nav-secondary-item [config]="secondaryNavConfig"
                                                 [menuGuards]="menuGuards"
                                                 [selectedPrimaryNavConfigId]="selectedPrimaryNavConfig.id"></app-infopost-sidebar-nav-secondary-item>
      </ng-container>
      }
    </div>
  </div>
</div>
